module.exports = __webpack_public_path__ + "static/tara-logo-0e5323df52d8ad9060e1d64345b73431.svg";